import * as React from "react";

export default class searchDesktop extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
        <svg  className={this.props.className} onClick={this.props.onClick} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.4731 18.9448C15.6005 18.9448 18.9463 15.5993 18.9463 11.4724C18.9463 7.34552 15.6005 4 11.4731 4C7.34584 4 4 7.34552 4 11.4724C4 15.5993 7.34584 18.9448 11.4731 18.9448Z" stroke="#1F36C7" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M20.0006 20.0002L16.75 16.75" stroke="#1F36C7" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
  }
}
